import React from 'react';
import TableBody from 'components/data-visualization/Table/Body';
import ChartTableRow from './tableRow';
import { IChartTrackData } from 'helpers/interceptors/chartsTableDataInterceptor';

const ChartTableBody: React.FC<{
  tracks: IChartTrackData[];
  chartName: string | undefined;
  isLargeScreen: boolean;
}> = (props) => {
  const { tracks, isLargeScreen, chartName } = props;

  return (
    <TableBody>
      {tracks.map((track: IChartTrackData) => (
        <ChartTableRow
          key={track.artistName + track.productTitle + chartName}
          trackData={track}
          isLargeScreen={isLargeScreen}
        />
      ))}
    </TableBody>
  );
};

export default ChartTableBody;
